module.exports = __webpack_public_path__ + "static/media/rules.2fbdb702.svg";